// export class ConfigDB {
// 	static data = {
// 		settings: {
// 			layout_type: 'ltr',
// 			sidebar: {
// 				type: 'compact-wrapper',
// 				body_type: 'sidebar-icon'
// 			},
// 			sidebar_setting: 'default-sidebar',
// 		},
// 		color: {
// 			layout_version: 'light',
// 			color: 'color-1',
// 			primary_color: '#7366ff',
// 			secondary_color: '#f73164',
// 			mix_background_layout: 'light-only',
// 		},
// 		router_animation: 'fadeIn'
// 	}
// }
// export default ConfigDB;

 let typeMenu = localStorage.getItem('menu') === "True";

const sidebarType = typeMenu
  ? "compact-wrapper modern-type"
  : "horizontal-wrapper enterprice-type";


export class ConfigDB {
	static data = {
		"settings": {
			"layout_type": "ltr",
			"sidebar": {
				"type": sidebarType
			},
			"sidebar_setting": "default-sidebar"
		},
		"color": {
			// "layout_version": "dark-only",
			"layout_version": "light",
			"color": "color-1",
			"primary_color": "#46AFE5",
			"secondary_color": "#0079C7",
			"danger_color": "##ff0018",

			"after_color": "#204887",
			// "mix_background_layout": "dark-only"
			"mix_background_layout": "light-only"
		},
		"router_animation": "fadebottom"
	}
}
// export class ConfigDB {
//   static data = {
//        settings: {
//            layout_type:  'ltr',
//        sidebar: {
//            type: 'compact-wrapper modern-type',
//        },
//        sidebar_setting: 'default-sidebar', 
//        },
//        color: {
// 			"primary_color": "#46AFE5",
// 			"secondary_color": "#0079C7",
// 			"danger_color": "##ff0018",
// 			"after_color": "#204887",
//         mix_background_layout: 'light-only', 
//        },
//        router_animation: 'fadeIn'
//    }
//  }
export default ConfigDB;